<div class="info">
  <mat-icon>info_outline</mat-icon>
  <label>Ha ocurrido un problema.</label>
</div>
